// extracted by mini-css-extract-plugin
export default {"chevron":"MenuButton_chevron__xXLG7"};